/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentGroupDetails } from '../../models/agent-group-details';
import { ApiResponseAgentGroup } from '../../models/api-response-agent-group';

export interface UpdateAgentGroup$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
      body: AgentGroupDetails
}

export function updateAgentGroup(http: HttpClient, rootUrl: string, params: UpdateAgentGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAgentGroup>> {
  const rb = new RequestBuilder(rootUrl, updateAgentGroup.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseAgentGroup>;
    })
  );
}

updateAgentGroup.PATH = '/v1/api/ui/agent-group/{ref}';
